import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";
import { useNavigate } from "react-router-dom";
import { SwitcherStreamSetting } from "@switcherstudio/switcher-api-client";
import { addNotification } from "store/notification/slice";
import { NotificationType } from "store/notification/types";
import { client } from "api/client";
import { useSwitcherSdk } from "hooks/useSwitcherSdk";
import { CustomRTMPChannelForm } from "./CustomRTMPChannelForm";
import { CustomRTMPChannelPage } from "views/page-content/CustomRTMPChannelPage";
interface AddCustomRTMPChannelPageProps {
    finalUrl?: string;
}
export const AddCustomRTMPChannelPage: React.FC<
    AddCustomRTMPChannelPageProps
> = ({ finalUrl }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { isInBrowser } = useSwitcherSdk();

    const [channel, setChannel] = useState<SwitcherStreamSetting>({
        "audio-bit-rate": null,
        "audio-channel-count": null,
        "audio-sample-rate": null,
        "rtmp-stream": "",
        url: "",
        version: "1.0",
        "video-bit-rate": null,
        "video-frame-height": 360,
        "video-frame-width": 640,
        "user-editable": true,
        "channel-name": "My New Channel",
        "is-deleted": false
    });

    const onChange = useCallback((update: { [key: string]: any }) => {
        setChannel((prev) => {
            return {
                ...prev,
                ...update
            };
        });
    }, []);

    const createChannel = useCallback(async () => {
        const regx = /^(rtmp|rtmps):\/\/[^ "]+$/i;
        const isRtmpUrl = regx.test(channel.url);

        if (!isRtmpUrl) {
            dispatch(
                addNotification({
                    type: NotificationType.Danger,
                    message: t("platforms:invalid-rtmp-error")
                })
            );
            return;
        }

        try {
            await client.switcherStreamSettings_PostSwitcherStreamSetting(
                channel
            );
            navigate(
                finalUrl || isInBrowser ? "/manage-platforms" : "/platforms"
            );
        } catch (err) {
            dispatch(
                addNotification({
                    type: NotificationType.Danger,
                    message: t("platforms:channel-settings-error")
                })
            );
        }
    }, [channel, dispatch, navigate, t, finalUrl, isInBrowser]);

    return (
        <>
            {/* If running in a browser context (isInBrowser), we use native event
            creation; otherwise, we render the dashboard in a webview */}
            {isInBrowser ? (
                <CustomRTMPChannelPage
                    btnText={t("buttons:save")}
                    setting={channel}
                    onChange={onChange}
                    onPrimaryClick={createChannel}
                />
            ) : (
                <CustomRTMPChannelForm
                    btnText={t("buttons:save")}
                    setting={channel}
                    onChange={onChange}
                    onPrimaryClick={createChannel}
                />
            )}
        </>
    );
};
